import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchDelete(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete('/transit/v1/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
          },
        fetchData(ctx, queryParams){

            var data = JSON.stringify(queryParams);
            // ชconsole.log('queryParams',data);
            return new Promise((resolve, reject) => {

                axios
                .post('transit/v1/lists', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
        fetchUpdate(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                .put('transit/v1/update/'+queryParams.id, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

    }
}